export const getIsServicesEnabled = () => window.Jbhifi?.servicesEnabled;
